// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserReviewBox{display:flex;flex-direction:column}.UserReviewBox .StarRating{margin-bottom:.875rem}.UserReviewBox__author{color:#606060;font-size:.875rem;font-weight:700;line-height:1.375rem}.UserReviewBox__description{color:#606060;font-size:.75rem;line-height:1.25rem;margin-bottom:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
